import React from 'react';

const NewMexico = () => (
  <svg
    width="93"
    height="97"
    viewBox="0 0 93 97"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.1532 16.515C90.3999 22.8025 90.5407 29.5125 90.1323 35.969C89.3298 48.6496 88.499 61.288 87.5697 73.856C87.1192 79.9886 86.8939 86.0015 85.521 91.775C68.5332 90.6767 51.9185 89.2051 35.353 87.6772C33.593 88.3391 36.7118 91.0005 35.353 91.261C28.0735 90.3528 20.2871 89.9444 13.3385 88.6982C11.839 90.4373 12.5711 94.4154 11.2898 96.3798C7.95282 95.6194 3.63721 95.8447 0.539551 94.8448C4.36234 63.1749 8.68498 31.9979 12.3106 0.130859C38.4929 2.95425 64.3021 6.15785 92.174 7.29848L91.1532 16.515Z"
      fill="#FC374D"
    />
  </svg>
);
export default NewMexico;
